// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDPdsKvBFZusKefpCsuVKMoN7swAX109Sc",
    authDomain: "ural-64499.firebaseapp.com",
    projectId: "ural-64499",
    storageBucket: "ural-64499.appspot.com",
    messagingSenderId: "783043528365",
    appId: "1:783043528365:web:bb6dbaddc41b0d9102e824"
};

export default firebaseConfig;